export const getLatestVersion = (app) => {
  if (app.versions.length === 1) {
    return app.versions[0];
  }
  const versions = app.versions.sort(
    (a, b) => b.versionNumber - a.versionNumber
  );
  return versions[0];
};
